<template>
  <div class="card" id="addNew">
    <b-card-header class="border-0">
      <div class="d-flex align-items-center">
        <h5 class="card-title mb-0 flex-grow-1">{{this.$t('page.repair-request.SolicitedMessage')}}</h5>
      </div>
    </b-card-header>
    <b-card-body class="border-top">
      <!-- 第一行 -->
      <b-row>
        <b-col cols="6">
          <label for="weight-field" class="form-label">
            <span>{{this.$t('menu.business-partner.customer')}}</span>
            <span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span>
          </label>
          <Multiselect
            v-model="form.customer"
            :close-on-select="true"
            :searchable="true"
            label="name"
            value-prop="id"
            :options="customerOptions"
            :loading="customerLoading"
            :placeholder="this.$t('serviceCompany.company_name')"
            :class="{
              'is-invalid': submitted && v$.form.customer.$error,
            }"
            required
          />
          <div
            v-for="(item, index) in v$.form.customer.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
        <b-col cols="6">
          <label for="weight-field" class="form-label">
            <span>{{this.$t('page.detailedAddress')}}</span>
          </label>
          <input
            type="text"
            class="form-control"
            :placeholder="this.$t('page.detailedAddress')"
            v-model="form.customer_address"
          />
        </b-col>
      </b-row>
      <!-- 第二行 -->
      <b-row class="mt-4">
        <b-col cols="4">
          <label for="weight-field" class="form-label">
            <span>{{ $t('page.work-order.device-root-sn') }}</span>
            <span v-if="currentProductType == 1 && currentGroupSn">（{{this.$t('page.unit_serial_number')}}：{{ currentGroupSn }}）</span>
<!--            <span class="text-danger">（必填）</span>-->
          </label>
          <DeviceSelect
              :customer-id="form.customer"
              :snNum="form.device_root_sn"
              @changed="deviceChange"
          />
        </b-col>
        <b-col cols="4">
          <label for="weight-field" class="form-label">
            <span>{{this.$t('page.contactNumber')}}</span>
            <span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span>
          </label>
          <Multiselect
              :class="v$.form.customer_contact_number.$error ? 'is-invalid' : ''"
              class="form-control"
              :value="form.customer_contact_number"
              v-model="form.customer_contact_number"
              :placeholder="this.$t('page.contactNumber')"
              value-prop="tel"
              label="tel"
              @change="setCurrentContactName"
              :close-on-select="true"
              :searchable="true"
              :create-option="true"
              :options="contactsList"
          />
          <div
            v-for="(item, index) in v$.form.customer_contact_number.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
        <b-col cols="4">
          <label for="weight-field" class="form-label">
            <span>{{this.$t('page.contact')}}</span>
            <span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span>
          </label>
          <Multiselect
              :class="v$.form.customer_contact.$error ? 'is-invalid' : ''"
              class="form-control"
              :value="form.customer_contact"
              v-model="form.customer_contact"
              :placeholder="this.$t('page.contact')"
              value-prop="id"
              label="name"
              @change="setCurrentContactTel"
              :close-on-select="true"
              :searchable="true"
              :create-option="true"
              :options="contactsList"
          />
          <div
            v-for="(item, index) in v$.form.customer_contact.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
      </b-row>
      <!-- 紧急程度 -->
      <b-row class="mt-4">
        <b-col cols="4">
          <label for="weight-field" class="form-label">
            <span>{{this.$t('page.repair-request.RequestType')}}</span>
          </label>
          <Multiselect
              v-model="form.type"
              :close-on-select="true"
              :searchable="false"
              :options="WO_TYPE"
              :placeholder="this.$t('page.select-type')"
          />
        </b-col>
        <b-col cols="4">
          <label for="weight-field" class="form-label">
            <span>{{this.$t('page.expected-service-time')}}</span>
            <span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span>
          </label>
          <flat-pickr
              v-model="form.expectation_at"
              :placeholder="this.$t('page.select-time')"
              :config="dateconfig"
              class="form-control"
              :class="{
              'is-invalid': submitted && v$.form.expectation_at.$error,
            }"
              required
          ></flat-pickr>
          <div
              v-for="(item, index) in v$.form.expectation_at.$errors"
              :key="index"
              class="invalid-feedback"
          >
            <span v-if="item.$message">{{ item.$message }}</span>
          </div>
        </b-col>
        <b-col>
          <label for="weight-field" class="form-label">
            <span>{{this.$t('page.work-order.priority.text')}}</span>
            <span class="text-danger">{{this.$t('serviceCompany.not_null')}}</span>
          </label>
          <div class="d-flex priority-btn">
            <div
              v-for="(list, index) in priorityList"
              :key="index"
              :class="[
                'priority-common cursor-pointer',
                `priority-${list.value}`,
                currentChoose == index && 'active',
              ]"
              @click="handlerChoosepriority(index, list.value)"
            >
              <div class="btn-text">{{ list.label }}</div>
            </div>
          </div>
          <div class="priority-error" v-if="show_priority_error">
            {{this.$t('page.repair-request.TheDegreeOfUrgencyIsRequired')}}
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <label for="weight-field" class="form-label">
            <span>{{this.$t('page.problem_description')}}</span>
          </label>
          <textarea type="text" class="form-control" v-model="form.content" />
        </b-col>
      </b-row>
      <!-- 附件 -->
      <b-row class="mt-4">
        <b-col>
          <UploadFiles
            input-file-id="filesUpload"
            :title="this.$t('page.attachment')"
            :files="files"
            :showFileList="showFileList"
            @changed="filesUpload"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </div>
  <div class="submit-btn position-relative text-end mt-4">
    <button
      type="button"
      class="btn btn-outline-primary waves-effect waves-light btn-common me-4"
      @click="handlerClose"
    >
      {{this.$t('base.cancel')}}
    </button>
    <button
      type="button"
      class="btn btn-primary waves-effect waves-light btn-common"
      @click="handlerSubmit"
    >
      <span class="d-flex align-items-center">
        <span class="flex-grow-1 me-2">{{this.$t('base.submit')}}</span>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="submitLoading"></span>
      </span>
    </button>
  </div>
  <message-alert
    :alertInfo="alertInfo"
    v-if="formValidataAlert"
  ></message-alert>
</template>

<script>
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import UploadFiles from "@/views/widgets/upload-files";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import {
  customerDetail,
  postRepairService,
  getUploadFileSign,
  putFiles,
  getUploadFileDetail,
  postUpdateFile,
  deleteFile, postCustomerContact,
} from "@/service/index";
import {getCustomerContactList, getCustomers} from "@/helpers/common-service";
import {WO_TYPE, SERVICE_STATUS_PENDING} from "@/config/common";
import DeviceSelect from "@/views/widgets/device-select";
import {addressText} from "@/helpers/common";
import {alertError} from "@/helpers/swal";
import i18n from "@/i18n";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    form: {
      customer: {
        required: helpers.withMessage(i18n.global.t('page.repair-request.TheCompanyNameIsRequired'), required),
      },
      // device_root_sn: {
      //   required: helpers.withMessage("泵头序列号是必填项", required),
      // },
      expectation_at: {
        required: helpers.withMessage(i18n.global.t('page.repair-request.ExpectedServiceTimeIsRequired'), required),
      },
      customer_contact_number: {
        required: helpers.withMessage(i18n.global.t('page.work-order.contact-phone-required'), required),
      },
      customer_contact: {
        required: helpers.withMessage(i18n.global.t('page.work-order.contact-required'), required),
      },
    },
  },
  data() {
    return {
      WO_TYPE,
      submitted: false,
      showFileList: false,
      alertInfo: {
        variant: "danger",
        content: "",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      form: {
        customer: "",
        customer_address: "",
        device_root_sn: "",
        device_name: "",
        expectation_at: "",
        customer_contact_number: "",
        customer_contact: "",
        priority: "",
        content: "",
        attachment: [],
        type: "",
      },
      files: [],
      dateconfig: {
        wrap: true,
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      customerOptions: [],
      customerLoading: false,
      priorityList: [
        {
          label: this.$t('page.work-order.priority.not-urgent'),
          value: 1,
        },
        {
          label: this.$t('page.work-order.priority.urgent'),
          value: 2,
        },
        {
          label: this.$t('page.work-order.priority.very-urgent'),
          value: 3,
        },
      ],
      currentChoose: null,
      show_priority_error: false,
      contactsList: [], // 联系人列表
      submitLoading: false,
      currentGroupSn: null,
      currentProductType: null,
    };
  },
  mounted() {
    if(this.$route.query.id){
      this.form.customer=this.$route.query.id
      this.form.device_root_sn = this.$route.query.sn
      this.form.type='5'
    }
    this.initCustomer();
  },
  watch: {
    "form.customer"(val) {
      // 查客户详情获取地址
      customerDetail(val).then(res => {
        const detail = res.payload
        this.form.customer_address = addressText(detail)
      })
      // 清空联系人
      this.form.customer_contact = null
      this.form.customer_contact_number = null
      // 获取该客户下的联系人列表
      getCustomerContactList(val).then(res => {
        this.contactsList = res
      })

    },
    "form.priority"(val) {
      if (val) {
        this.show_priority_error = false;
      }
    },
  },
  methods: {
    initCustomer() {
      this.customerLoading = true
      getCustomers().then((res) => {
        if (res) {
          this.customerOptions = res;
          this.customerLoading = false
        }
      });
    },
    // 选择电话后自动填充联系人姓名
    setCurrentContactName(value) {
      const contact = _.find(this.contactsList, {tel: value})
      if (contact) {
        this.form.customer_contact = contact.id
      } else if(typeof this.form.customer_contact === 'number') {
        this.form.customer_contact = null
      }
    },
    // 选择联系人后自动填充联系人电话
    setCurrentContactTel(value) {
      const contact = _.find(this.contactsList, {id: value})
      if (contact) {
        this.form.customer_contact_number = contact.tel
      } else if (_.find(this.contactsList, {tel: this.form.customer_contact_number})) {
        this.form.customer_contact_number = null
      }
    },
    deviceChange(val) {
      this.form.device_root_sn = val.root_sn
      this.form.device_name = val.name
      this.currentGroupSn = val.group_sn
      this.currentProductType = val.product_type
    },
    filesUpload(file, type) {
      if (!file) {
        return;
      }
      if (type == "add") {
        this.updateFiles(file[0], type);
      } else {
        this.updateFiles(file, type);
      }
    },
    /* 上传文件 */
    updateFiles(file, type) {
      if (type == "add") {
        let filename = file.name;
        let objectName = `repair/${uuidv4()}/${filename}`;
        let signParams = {
          object: objectName,
          method: "upload",
        };
        getUploadFileSign(signParams).then((sign) => {
          if (sign && sign.payload) {
            putFiles(sign.payload.signedUrl, file, file.type).then(() => {
              let detailOption = {
                object: objectName,
              };
              getUploadFileDetail(detailOption).then((detail) => {
                if (detail && detail.payload) {
                  let info = {
                    url: detail.payload.url,
                    etag: detail.payload.etag,
                    size: detail.payload.size,
                    content_type: detail.payload.contentType,
                    object_name: detail.payload.objectName,
                    last_modified: detail.payload.lastModified,
                  };
                  postUpdateFile(info).then((post) => {
                    if (post && post.payload) {
                      this.showFileList = true;
                      let file = _.cloneDeep(post.payload);
                      file.name = filename;
                      this.files.push(file);
                      this.form.attachment.push(file.id);
                      this.formValidataAlert = true;
                      this.alertInfo = {
                        variant: "success",
                        content: this.$t("base.upload_success"),
                        icon: "ri-alert-line",
                      };
                      setTimeout(() => {
                        this.formValidataAlert = false;
                      }, 3000);
                    }
                  });
                }
              });
            });
          }
        });
      } else {
        let params = { object: file.object_name };
        deleteFile(params).then((res) => {
          if (res && res.payload) {
            document.querySelector("#filesUpload").value = "";
            this.files = this.files.filter((f) => {
              return f.object_name != file.object_name;
            });
            this.formValidataAlert = true;
            this.alertInfo = {
              variant: "success",
              content: this.$t("base.delete_success"),
              icon: "ri-alert-line",
            };
            setTimeout(() => {
              this.formValidataAlert = false;
            }, 3000);
          }
        });
      }
    },
    handlerChoosepriority(index, value) {
      this.currentChoose = index;
      this.form.priority = value;
    },
    handlerSubmit() {
      console.log(this.form)
      if (this.submitLoading) {
        return;
      }
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      if (!this.form.priority) {
        this.show_priority_error = true;
        return;
      }
      this.submitLoading = true
      // 如果联系人列表中没有，则新建联系人，再保存
      if (!_.find(this.contactsList, ['id', this.form.customer_contact])) {
        const contactData = {
          customer: this.form.customer,
          name: this.form.customer_contact,
          tel: this.form.customer_contact_number,
        }
        postCustomerContact(contactData).then((res) => {
          this.form.customer_contact = res.payload.id
          this.saveRequest()
        }).catch(err => {
          console.log(err)
          this.submitLoading = false
          alertError(this.$t('base.prompt'), `${this.$t('page.work-order.create-customer-contact-error')}!`)
        })
      } else {
        // 直接保存
        this.saveRequest()
      }

    },
    saveRequest() {
      let params = _.cloneDeep(this.form);
      params.customer = Number(params.customer);
      // 一提交状态就是待处理
      params['status'] = SERVICE_STATUS_PENDING
      if (!params['type']) {
        params['type'] = '0'
      }
      postRepairService(params)
          .then((res) => {
            if (res && res.payload) {
              this.formValidataAlert = true;
              this.alertInfo = {
                variant: "success",
                content: this.$t("base.submit_success"),
                icon: "ri-alert-line",
              };
              setTimeout(() => {
                this.submitLoading = false
                this.formValidataAlert = false;
                this.$router.push({
                  path: "/repair-request",
                });
              }, 3000);
            }
          })
          .catch(() => {
            this.submitLoading = false
            this.formValidataAlert = true;
            this.alertInfo = {
              variant: "danger",
              content: this.$t("base.submit_failed"),
              icon: "ri-alert-line",
            };
            setTimeout(() => {
              this.formValidataAlert = false;
            }, 3000);
          });
    },
    handlerClose() {
      this.$router.push({
        path: "/repair-request/list",
      });
    },
  },
  components: {
    UploadFiles,
    DeviceSelect,
  },
};
</script>

<style scoped lang="scss">
#addNew {
  width: 60%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 100px;
}
.priority-common {
  border: 1px solid;
  text-align: center;
  .btn-text {
    padding: 8px 10px;
    min-width: 100px;
  }
}
.priority-1 {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  color: #0ab39c;
  &.active {
    background-color: #0ab39c;
    color: #fff;
  }
}
.priority-2 {
  color: #f7b84b;
  &.active {
    background-color: #f7b84b;
    color: #fff;
  }
}
.priority-3 {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #ed5e5e;
  &.active {
    background-color: #ed5e5e;
    color: #fff;
  }
}
.priority-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #f06548;
}
.submit-btn {
  width: 60%;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 1400px) {
  #addNew {
    width: 80%;
  }
  .submit-btn {
    width: 80%;
  }

}
</style>
